import { components, useApi } from "@appretio/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateCubeMutation } from "../cubeMutationInvalidation";

type AddDimInput = components["schemas"]["AddDimInput"];

export function useAddDim() {
  const apiClient = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: AddDimInput) => {
      const response = await apiClient.POST("/v2/forecast/cubes/add-dim", {
        body: input
      });
      if (!response.data?.result) {
        throw new Error("Missing result in add dimension response");
      }
      return response.data.result;
    },
    onSuccess: async () => {
      await invalidateCubeMutation(queryClient, { lifecycle: true });
    },
    meta: {
      errorMessage: "Failed to add dimension"
    }
  });
}
